module.exports = __webpack_public_path__ + "img/radio_off.5c78f1b5.svg";